import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import homeEn from './locales/en/home.json';
import headerEn from './locales/en/header.json';
import healthEn from './locales/en/health.json';
import profileEn from './locales/en/profile.json';
import insuranceEn from './locales/en/insurance.json';
import servicesEn from './locales/en/services.json';
import supportEn from './locales/en/support.json';
import notificationsEn from './locales/en/notifications.json';
import womensHealthEn from './locales/en/womensHealth.json';
import childDevEn from './locales/en/childDev.json';
import elderlyEn from './locales/en/elderly.json';
import footerEn from './locales/en/footer.json';
import modalsEn from './locales/en/modals.json';
import teleconsultEn from './locales/en/teleconsult.json';
import assessmentEn from './locales/en/assessment.json';
import familyDoctorEn from './locales/en/familyDoctor.json';

// Hindi
import commonHi from './locales/hi/common.json';
import authHi from './locales/hi/auth.json';
import homeHi from './locales/hi/home.json';
import headerHi from './locales/hi/header.json';
import healthHi from './locales/hi/health.json';
import profileHi from './locales/hi/profile.json';
import insuranceHi from './locales/hi/insurance.json';
import servicesHi from './locales/hi/services.json';
import supportHi from './locales/hi/support.json';
import notificationsHi from './locales/hi/notifications.json';
import womensHealthHi from './locales/hi/womensHealth.json';
import childDevHi from './locales/hi/childDev.json';
import elderlyHi from './locales/hi/elderly.json';
import footerHi from './locales/hi/footer.json';
import modalsHi from './locales/hi/modals.json';
import teleconsultHi from './locales/hi/teleconsult.json';
import assessmentHi from './locales/hi/assessment.json';
import familyDoctorHi from './locales/hi/familyDoctor.json';

// Kannada
import commonKn from './locales/kn/common.json';
import authKn from './locales/kn/auth.json';
import homeKn from './locales/kn/home.json';
import headerKn from './locales/kn/header.json';
import healthKn from './locales/kn/health.json';
import profileKn from './locales/kn/profile.json';
import insuranceKn from './locales/kn/insurance.json';
import servicesKn from './locales/kn/services.json';
import supportKn from './locales/kn/support.json';
import notificationsKn from './locales/kn/notifications.json';
import womensHealthKn from './locales/kn/womensHealth.json';
import childDevKn from './locales/kn/childDev.json';
import elderlyKn from './locales/kn/elderly.json';
import footerKn from './locales/kn/footer.json';
import modalsKn from './locales/kn/modals.json';
import teleconsultKn from './locales/kn/teleconsult.json';
import assessmentKn from './locales/kn/assessment.json';
import familyDoctorKn from './locales/kn/familyDoctor.json';

export const supportedLanguages = {
  en: { label: 'English', nativeLabel: 'English', flag: '🇬🇧' },
  hi: { label: 'Hindi', nativeLabel: 'हिन्दी', flag: '🇮🇳' },
  kn: { label: 'Kannada', nativeLabel: 'ಕನ್ನಡ', flag: '🇮🇳' },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        auth: authEn,
        home: homeEn,
        header: headerEn,
        health: healthEn,
        profile: profileEn,
        insurance: insuranceEn,
        services: servicesEn,
        support: supportEn,
        notifications: notificationsEn,
        womensHealth: womensHealthEn,
        childDev: childDevEn,
        elderly: elderlyEn,
        footer: footerEn,
        modals: modalsEn,
        teleconsult: teleconsultEn,
        assessment: assessmentEn,
        familyDoctor: familyDoctorEn,
      },
      hi: {
        common: commonHi,
        auth: authHi,
        home: homeHi,
        header: headerHi,
        health: healthHi,
        profile: profileHi,
        insurance: insuranceHi,
        services: servicesHi,
        support: supportHi,
        notifications: notificationsHi,
        womensHealth: womensHealthHi,
        childDev: childDevHi,
        elderly: elderlyHi,
        footer: footerHi,
        modals: modalsHi,
        teleconsult: teleconsultHi,
        assessment: assessmentHi,
        familyDoctor: familyDoctorHi,
      },
      kn: {
        common: commonKn,
        auth: authKn,
        home: homeKn,
        header: headerKn,
        health: healthKn,
        profile: profileKn,
        insurance: insuranceKn,
        services: servicesKn,
        support: supportKn,
        notifications: notificationsKn,
        womensHealth: womensHealthKn,
        childDev: childDevKn,
        elderly: elderlyKn,
        footer: footerKn,
        modals: modalsKn,
        teleconsult: teleconsultKn,
        assessment: assessmentKn,
        familyDoctor: familyDoctorKn,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common', 'auth', 'home', 'header', 'health', 'profile',
      'insurance', 'services', 'support', 'notifications',
      'womensHealth', 'childDev', 'elderly', 'footer', 'modals', 'teleconsult', 'assessment', 'familyDoctor',
    ],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
